import { NextFunction, Request, Response } from 'express'

export const protectedCtrl = async (
  req: Request,
  res: Response,
  next: NextFunction,
) => {
  return res.status(200).json({ message: 'protected route' })
}
